/**
 * Tier1Section — Public Access tier.
 * Mobile: full-width stacked. Desktop: ~1/3 width left column.
 * No default green tick on header — tick shows per folder after all docs accessed.
 */
import FolderItem from './FolderItem';
import { formatFolderDisplayName } from './utils';

const Tier1Section = ({ tier1Folders, expandedFolders, fileErrors, onFolderToggle, onFileActivate, isFolderComplete }) => {
  const hasFolders = Array.isArray(tier1Folders) && tier1Folders.length > 0;

  return (
    <div className="ddv-tier-card ddv-tier-card--tier1">
      <div className="ddv-tier-header ddv-tier-header--tier1">
        <h3 className="ddv-tier-title">Public Access</h3>
      </div>
      <div className="ddv-tier-body">
        {hasFolders ? (
          <div className="ddv-folder-grid ddv-folder-grid--tier1">
            {tier1Folders.map(([folderName, docsMap]) => {
              const isExpanded = expandedFolders instanceof Set && expandedFolders.has(folderName);
              const isComplete = isFolderComplete(docsMap);
              return (
                <FolderItem
                  key={folderName}
                  folderName={formatFolderDisplayName(folderName)}
                  docs={Object.values(docsMap || {})}
                  isExpanded={isExpanded}
                  isLocked={false}
                  isComplete={isComplete}
                  fileErrors={fileErrors}
                  onToggle={() => onFolderToggle(folderName)}
                  onFileActivate={onFileActivate}
                />
              );
            })}
          </div>
        ) : (
          <p className="ddv-empty">No documents available</p>
        )}
      </div>
    </div>
  );
};

export default Tier1Section;
